import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_CHAT_SLA } from "@faire/web-api--source/indigofair/settings/HELP_CENTER_CHAT_SLA";

export const getSettingChatSLA = (): number => {
  return getSettingValueWithoutAssignment(HELP_CENTER_CHAT_SLA, 180000);
};
